import type { RefundReason } from '@salonomy/types';

/**
 * Human labels for the refund-reason picker (WS6 §refunds). The codes are the canonical reportable set
 * from @salonomy/types (`RefundReason`) — presentation only; the reason a refund carries is always one
 * of these codes. This is the REFUND reason set, distinct from the till's DISCOUNT reasons
 * (features/till/reasonLabels.ts) — a refund moves money back, a discount reduces a price, so they have
 * separate, non-interchangeable reason vocabularies and must never be cross-wired.
 */
export const REFUND_REASON_LABELS: Record<RefundReason, string> = {
  requested_by_customer: 'Requested by customer',
  duplicate: 'Duplicate charge',
  fraudulent: 'Fraudulent',
  no_show_waived: 'No-show fee waived',
  other: 'Other',
};

/** The order the picker offers them in. */
export const REFUND_REASON_ORDER: RefundReason[] = [
  'requested_by_customer',
  'duplicate',
  'fraudulent',
  'no_show_waived',
  'other',
];
